import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';

const CalendarSetupComplete = () => {
    const location = useLocation();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const success = urlParams.get('success');
        const error = urlParams.get('error');

        const timer = setTimeout(() => {
            if (success === 'true') {
                toast.success('Google Calendar connected successfully!');
                setIsLoading(false);
            } else if (success === 'false') {
                const errorMessage = error ? decodeURIComponent(error) : 'Failed to connect calendar';
                toast.error(`Connection failed: ${errorMessage}`);
                setIsLoading(false);
            } else {
                toast.error('Invalid parameters');
                history.push('/events');
            }
        }, 1500);

        return () => clearTimeout(timer);
    }, [location, history]);

    const handleClose = () => {
        window?.close();
    };

    if (isLoading) {
        return (
            <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                <Card className="text-center p-4">
                    <Card.Body>
                        <Spinner animation="border" variant="primary" className="mb-3" />
                        <h4>Setting up your calendar connection...</h4>
                        <p className="text-muted">Please wait while we complete the setup.</p>
                    </Card.Body>
                </Card>
            </Container>
        );
    }

    const urlParams = new URLSearchParams(location.search);
    const success = urlParams.get('success');
    const error = urlParams.get('error');

    return (
        <Container className="py-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <Card>
                        <Card.Body className="text-center p-4">
                            {success === 'true' ? (
                                <>
                                    <div className="text-success mb-3">
                                        <i className="fas fa-check-circle" style={{ fontSize: '3rem' }}></i>
                                    </div>
                                    <h3 className="text-success mb-3">Calendar Connected!</h3>
                                    <p className="mb-4">
                                        Your Calendar has been successfully connected. You can now sync your events and
                                        manage your calendar integration.
                                    </p>
                                    <Button variant="primary" onClick={handleClose} className="px-4">
                                        Close
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <div className="text-danger mb-3">
                                        <i className="fas fa-times-circle" style={{ fontSize: '3rem' }}></i>
                                    </div>
                                    <h3 className="text-danger mb-3">Connection Failed</h3>
                                    <Alert variant="danger">
                                        {error
                                            ? decodeURIComponent(error)
                                            : 'An unknown error occurred while connecting your calendar.'}
                                    </Alert>
                                    <p className="mb-4">Don't worry! You can try connecting your calendar again.</p>
                                    <div className="d-gap-2">
                                        <Button variant="primary" onClick={handleClose} className="px-4">
                                            Close
                                        </Button>
                                    </div>
                                </>
                            )}
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </Container>
    );
};

export default CalendarSetupComplete;
